module.exports = __webpack_public_path__ + "new-sms-icon.svg?bcb58103eeb488f31be6b6449ace837b";